// Replace these variables with your actual Shopify store credentials and metafield details
const SHOP_URL = 'eleganza-production.myshopify.com';
const API_VERSION = '2021-07'; // Replace with the Shopify API version you're using
const API_KEY = '7bdf781a4aecd4dd664f62685c000950';
const API_PASSWORD = '33d4d98432e44664c647e8bfe8a017f9';
const METAFIELD_NAMESPACE = 'custom';
const METAFIELD_KEY = 'bestel_code';

// admin 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

// Function to retrieve a list of active products from Shopify using Storefront API
async function getActiveProducts() {
  const shopifyDomain = 'eleganza-production.myshopify.com'; // Replace with your Shopify store domain
  const storefrontAccessToken = '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'; // Replace with your Storefront API access token

  const query = `
    {
      shop {
        products(first: 10, query: "status:active") {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  `;

  const url = `https://${shopifyDomain}/api/2021-07/graphql.json`;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken,
    },
    body: JSON.stringify({ query }),
  });

  const responseData = await response.json();
  if (responseData.errors) {
    throw new Error(responseData.errors[0].message);
  }

  return responseData.data.shop.products.edges.map(edge => ({
    id: edge.node.id,
    title: edge.node.title,
  }));
}

// Example usage:
// getActiveProducts()
//   .then(activeProducts => {
//     console.log(activeProducts);
//   })
//   .catch(error => {
//     console.error(error);
//   });
